import React, { createContext, useMemo, useState } from 'react';

export enum ActiveWizard {
  PermissionsAssignment = 'PERMISSIONS_ASSIGNMENT',
}

export type BulkTeamManagementContextValue = {
  selectedChannelIds: string[];
  setSelectedChannelIds: (ids: string[]) => void;
  activeWizard: ActiveWizard | null;
  setActiveWizard: (wizard: ActiveWizard | null) => void;
};

const defaultValue: BulkTeamManagementContextValue = {
  selectedChannelIds: [],
  setSelectedChannelIds: () => {},
  activeWizard: null,
  setActiveWizard: () => {},
};

export const BulkTeamManagementContext = createContext<BulkTeamManagementContextValue>(
  defaultValue
);

export function BulkTeamManagementProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [selectedChannelIds, setSelectedChannelIds] = useState<string[]>([]);
  const [activeWizard, setActiveWizard] = useState<ActiveWizard | null>(null);

  const value = useMemo(
    () => ({ selectedChannelIds, setSelectedChannelIds, activeWizard, setActiveWizard }),
    [selectedChannelIds, activeWizard]
  );

  return (
    <BulkTeamManagementContext.Provider value={value}>
      {children}
    </BulkTeamManagementContext.Provider>
  );
}
